<template>
<div class="faq">
	<details
		v-for="(item, index) in faqs"
		:key="index"
		class="dropdown-faq"
	>
		<summary class="faq-title">
			<span class="faq-title__text">{{ item.question }}</span>
			<img
				class="faq-title__chevron"
				src="../assets/down-black.svg"
				alt=""
				aria-hidden="true"
				loading="lazy"
			>
		</summary>
		<div class="faq-answer" v-html="item.answer" />
	</details>
</div>
</template>

<script>
export default {
	props: {
		faqs: {
			type: Array,
			required: true,
		},
	},
}
</script>

<style lang="scss" scoped>
.faq {
	margin: 20px 0;
}

.dropdown-faq {
	margin-bottom: 10px;
	border: 1px solid #e2e8f0;
	border-radius: 8px;
	overflow: hidden;
	background: #fff;

	&:last-child {
		margin-bottom: 0;
	}

	&[open] .faq-title__chevron {
		transform: rotate(180deg);
	}
}

.faq-title {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	padding: 14px 18px;
	cursor: pointer;
	font-weight: 600;
	font-size: 17px;
	color: #191919;
	background: #f7faf8;
	list-style: none;

	&::-webkit-details-marker {
		display: none;
	}

	&::marker {
		content: '';
	}
}

.faq-title__text {
	flex: 1;
	text-align: left;
}

.faq-title__chevron {
	width: 16px;
	height: 16px;
	flex-shrink: 0;
	transition: transform 0.3s ease;
}

.faq-answer {
	padding: 14px 18px;
	border-top: 1px solid #e2e8f0;
	font-size: 16px;
	line-height: 1.6;
	color: #444;
}
</style>
